export default function isMelangeHome() {
  const url = (window.location.href || '').toLowerCase();
  return url.includes('melange-home-costco-next');
}
